import { FILTERS_UPDATED } from '../core/action-types'

export const updateFilters = (filters) => {
  return { type: FILTERS_UPDATED, payload: filters }
}
